module.exports = __webpack_public_path__ + "static/6-c593c6c794692b52d6e49b5368d841d6.jpg";